<template>
  <svg
    :width="width ? width : height ? height * (23 / 20) : 23"
    :height="height ? height : width ? width * (20 / 23) : 20"
    viewBox="0 0 23 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill-rule="nonzero" fill="none">
      <path d="M21.905 17.424c.71 1.23-.181 2.769-1.599 2.769H1.848c-1.42 0-2.307-1.54-1.599-2.769L9.48 1.423c.71-1.232 2.488-1.23 3.197 0l9.23 16.001z" :fill="iconColor"/>
      <path d="M11.077 14.116a1.77 1.77 0 1 0 0 3.538 1.77 1.77 0 0 0 0-3.538zM9.397 7.756l.286 5.231a.462.462 0 0 0 .46.436h1.868a.462.462 0 0 0 .46-.436l.286-5.23a.462.462 0 0 0-.46-.488H9.857a.462.462 0 0 0-.46.487z" :fill="strokeColor"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'advarsel',
  props: {
    iconColor: {
      type: String,
      default: '#FF000E',
    },
    strokeColor: {
      type: String,
      default: '#FFFFFF',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
